<template>
  <div class="report-8" dir="rtl">
    <div style="margin-top: 200px" v-if="pathLogo == m"></div>

    <div class="mlogo">
      <img class="wlogo" :src="pathLogo" />
    </div>
    <div v-for="(item, i) in allData" :key="i">
      <div
        v-if="i % 28 == 0"
        style="direction: initial"
        class="md-layout mt-25"
      >
        <div style="text-align: center" class="md-layout-item md-size-100">
          <h3 class="text-center">{{ name }}</h3>
          <h4 class="text-center">{{ desc }}</h4>
        </div>

        <div class="md-layout-item md-size-100 mt-25">
          <div class="text-center" style="direction: ltr; display: flex">
            <h4 style="margin-top: -10px" class="text-center">
              كشف حصر التضامن المستحقة لصالح الهيئة العامة لصندوق التضامن
              الإجتماعي لدى وزارة المالية للعاملين للمطابقة مع ماتم سداده للخصم
              المباشر
            </h4>
          </div>
        </div>

        <div class="md-layout-item md-size-100">
          <h4 class="text-left">
            تاريخ الطباعة :
            <span class="display: inline-block">{{ date }}</span>
          </h4>
        </div>
      </div>
      <section v-if="i % 28 == 0" class="table-header">
        <div class="first text-center">ر . م</div>
        <div class="second">
          <div class="one">
            <p><span>البيان</span></p>
            <p>الدخل الإجمالى</p>
            <p>حصة التأمين 1 %</p>
            <p><span>ملاحظات</span></p>
          </div>
          <div class="two">
            <p></p>
            <div>
              <p>درهم</p>
              <p>دينار</p>
            </div>
            <div>
              <p>درهم</p>
              <p>دينار</p>
            </div>
            <p></p>
          </div>
        </div>
      </section>
      <section class="table-body">
        <p class="index">{{ i + 1 }}</p>
        <div class="content">
          <p>{{ item.employeeName }}</p>
          <div>
            <p v-text="item.netSalary.toString().split('.')[1] || '000'"></p>
            <p v-text="item.netSalary.toString().split('.')[0] || '000'"></p>
          </div>
          <div>
            <p
              v-text="item.solidarityTax.toString().split('.')[1] || '000'"
            ></p>
            <p
              v-text="item.solidarityTax.toString().split('.')[0] || '000'"
            ></p>
          </div>
          <p></p>
        </div>
      </section>
      <section
        v-if="i % 28 == 27 || i + 1 == allData.length"
        class="table-footer"
      >
        <div>
          <p>مجموع المرتب :</p>
          <p>{{ totalSalary }}</p>
        </div>
        <div>
          <p>مجموع حصة التضامن :</p>
          <p>{{ totalSolidarityTax }}</p>
        </div>
      </section>
      <section v-if="i % 28 == 27 || i + 1 == allData.length" class="manger">
        <p>رئيس قسم الحسابات</p>
        <p>المراجعة الداخلية</p>
        <p>المراقب المالى</p>
      </section>
    </div>
  </div>
</template>

<script>
import env from "../../../env";

export default {
  props: [
    "date",
    "start",
    "finish",
    "allData",
    "name",
    "desc",
    "totalSalary",
    "totalSolidarityTax",
    "pathLogo",
  ],
  data() {
    return {
      m: env.mTop(),
    };
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/report-8";
</style>
